// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+2-y5","nav":"styles_nav__32IPl","logo":"styles_logo__x6cm7","login":"styles_login__8OwRV"};